<script>
export default {
    data() {
        return {
            platform: 'capterra'
        };
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/ReviewsSlider.vue